<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix class="float-right">
      <mat-icon>close</mat-icon>
    </span>
  </div>
</div>
<div class="row row_flex">
  <div class="col-md-12 text-center">
    <span
      ><img
        style="width: 17.125rem; height: 9.875rem"
        src="../../../../assets/icons/Shared/mailConfirmation.png"
      />
    </span>
  </div>
</div>
<div class="row row_flex">
  <div class="col-md-12 text-center mb-4">
    <span class="MM36 font-weight-bold" style="color: #013cdb">
      Congratulations!
    </span>
  </div>
  <div class="col-md-12 text-center">
    <span class="MM24 font-weight-bold">
      Your Mailbox has been successfully setup
    </span>
  </div>
</div>
<div class="row row_flex">
  <div class="col-md-12 text-center">
    <span class="MM24" style="font-weight: 500">
      You can now send, recieve & attach your emails to the claim.
    </span>
  </div>
</div>
